type HistoryDirection = "forward" | "back";
const historyIndexKey = "__jellyflixHistoryIndex";

function browserEntryIndex() {
  const index = Number((window as any).navigation?.currentEntry?.index);
  return Number.isFinite(index) ? index : undefined;
}

let historyIndex = browserEntryIndex() ?? Number(window.history.state?.[historyIndexKey]);
if (!Number.isFinite(historyIndex)) {
  historyIndex = 0;
  window.history.replaceState({ ...(window.history.state ?? {}), [historyIndexKey]: historyIndex }, "", window.location.href);
}

function preserveTelevisionPreview(path: string) {
  if (new URLSearchParams(window.location.search).get("tv") !== "1") return path;
  const next = new URL(path, window.location.origin);
  next.searchParams.set("tv", "1");
  return `${next.pathname}${next.search}${next.hash}`;
}

export function pushNavigationPath(path: string) {
  const resolvedPath = preserveTelevisionPreview(path);
  if (`${window.location.pathname}${window.location.search}` === resolvedPath) return;
  historyIndex = browserEntryIndex() ?? historyIndex + 1;
  window.history.pushState({ [historyIndexKey]: historyIndex }, "", resolvedPath);
  historyIndex = browserEntryIndex() ?? historyIndex;
}

export function replaceNavigationPath(path: string) {
  const resolvedPath = preserveTelevisionPreview(path);
  if (`${window.location.pathname}${window.location.search}` === resolvedPath) return;
  window.history.replaceState({ ...(window.history.state ?? {}), [historyIndexKey]: historyIndex }, "", resolvedPath);
}

export function popNavigationPath() {
  window.history.back();
  return true;
}

export function subscribeNavigationHistory(listener: (url: string, direction?: HistoryDirection) => void) {
  const handlePopState = (event: PopStateEvent) => {
    const nextIndex = browserEntryIndex() ?? Number(event.state?.[historyIndexKey]);
    const direction: HistoryDirection = Number.isFinite(nextIndex) && nextIndex > historyIndex ? "forward" : "back";
    if (Number.isFinite(nextIndex)) historyIndex = nextIndex;
    listener(window.location.href, direction);
  };
  window.addEventListener("popstate", handlePopState);
  return () => window.removeEventListener("popstate", handlePopState);
}
